import Vue from 'vue'
import FAQsApp from './FAQsApp.vue'

import './filters'

import axios from 'axios'

Vue.config.productionTip = false

axios.interceptors.request.use((config) => {
    config['headers']['Content-Type'] = 'application/json';
    config['headers']['X-Requested-With'] = 'XMLHttpRequest';
    return config;
},
(error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
    return res
},
async (error) => {
    if (error.response.status == 403 || error.response.status == 401) {
        await store.dispatch('logout')
        router.push('/login')
    }

    return Promise.reject(error)
});



new Vue({
  render: h => h(FAQsApp)
}).$mount('#faqs-app')
